import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { combineLatest, Subscription } from 'rxjs';
import { MktCommonModule } from 'src/app/common/mkt-common.module';
import { MktContentStorageService } from 'src/app/core/services/mkt-content-storage.service';


@Component({
  selector: 'app-faq-section',
  templateUrl: './faq-section.component.html',
  styleUrls: ['./faq-section.component.scss'],
  standalone: true,
  imports: [MktCommonModule]
})
export class FaqSectionComponent implements OnInit, OnDestroy {
  label: string;
  expandAll = false;
  faqContent: any = null;
  routeSub: Subscription = new Subscription();

  constructor(private _mktContentStorageService: MktContentStorageService,
    private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.getFaqContent();
  }

  ngOnDestroy() {
    this.routeSub.unsubscribe();
  }

  private getFaqContent() {
    this.routeSub = combineLatest([
      this.route.params,
    ]).subscribe(params => {
      const cardName = params[0]['cardName'].replace(/\./g, '');
      // Try to get card pricing details
      const mainPdpContentObject = this._mktContentStorageService.get('Product_Detail_Pages', 'copy', cardName, undefined);
      if (!mainPdpContentObject) {
        return;
      }
      this.faqContent = JSON.parse(mainPdpContentObject['faqSection']);
      if (!this.faqContent || !this.faqContent.faqActive) { return; }
      this.label = this.faqContent.expandAllText;
    });
    
  }

  toggleExpandAll() {
    this.label = null;
    this.expandAll = !this.expandAll;
    this.label = this.expandAll ? this.faqContent.collapseAllText : this.faqContent.expandAllText;
  }
}
